<template lang="html">
    <div>
        <about/>
    </div>
</template>

<script>
import About from '../components/aboutComponent'
export default {
    components:{
        About
    }
    
}
</script>